// variant of @vividseats/vivid-ui-kit/dist/components/menu/menu-body/menu-option/component.tsx

import React, { useContext } from 'react'

import { menuContext, MENU_OPTION_VALUE_ATTRIBUTE } from '@vividseats/vivid-ui-kit'
import classNames from 'classnames'

import styles from './styles.module.scss'

type Props = {
    className?: string
    value?: string
}

const MenuOption: React.FC<Props> = ({ className, children, value }) => {
    const { onKeySelect, onSelect } = useContext(menuContext)

    const props = {
        className: classNames(className, styles.menuOption),
        tabIndex: 0,
        onClick: onSelect,
        onKeyDown: onKeySelect,
        [MENU_OPTION_VALUE_ATTRIBUTE]: value,
        'data-testid': 'menu-option',
    }

    return <div {...props}>{children}</div>
}

export default MenuOption
